module.exports = __webpack_public_path__ + "media/logos/strava-2d6c846b.svg";